import { parseTankQrPayload } from "./qrPayload";

export type ScanDecision =
  | { kind: "accepted"; tankCode: string }
  | { kind: "invalid" }
  | { kind: "duplicate"; tankCode: string }
  | { kind: "locked" };

export class HallPatrolScannerSession {
  private actionLocked = false;
  private lastAcceptedCode: string | undefined;
  private lastAcceptedAtMs = Number.NEGATIVE_INFINITY;

  constructor(private readonly debounceMs = 1_500) {
    if (!Number.isFinite(debounceMs) || debounceMs < 0) {
      throw new Error("QR_DEBOUNCE_INVALID");
    }
  }

  consider(raw: string, observedAtMs: number): ScanDecision {
    if (this.actionLocked) {
      return { kind: "locked" };
    }

    const parsed = parseTankQrPayload(raw);

    if (parsed.kind !== "valid") {
      return { kind: "invalid" };
    }

    if (
      parsed.tankCode === this.lastAcceptedCode &&
      observedAtMs - this.lastAcceptedAtMs < this.debounceMs
    ) {
      return { kind: "duplicate", tankCode: parsed.tankCode };
    }

    this.lastAcceptedCode = parsed.tankCode;
    this.lastAcceptedAtMs = observedAtMs;
    this.actionLocked = true;

    return { kind: "accepted", tankCode: parsed.tankCode };
  }

  releaseAction(): void {
    this.actionLocked = false;
  }

  isActionLocked(): boolean {
    return this.actionLocked;
  }
}
